import { memo } from 'react';
import { useNavigate } from 'react-router-dom';
import { People } from '@mui/icons-material';
import { areClassNamePropsEqual } from '../utilities/utils';
import { members_page, navigateToPage } from '../controls/ProtectedPage';
import NavButton from './NavButton';

const MembersButton = ({ className, onClick }: { className?: string, onClick?: () => void }): JSX.Element => {
    const history = useNavigate();
    return <NavButton
        className={className}
        title="View our wonderful community of users, sessions and votes"
        onClickCallback={onClick}
        onNavigate={() => navigateToPage(members_page, history)}
        icon={<People fontSize='medium' />}
        label='Users'
    />
};

export default memo(MembersButton, areClassNamePropsEqual);
